<div class="bloco-unico">
  <h3 class="uppercase">Peso da NRT</h3>
  <hr>
  <div class="table-responsive container-fluid no-padding" *ngIf="pedido?.pesoNrt && pedido?.pesoNrt.length > 0">
    <table mat-table [dataSource]="grid">
      <ng-container matColumnDef="volume">
        <th mat-header-cell *matHeaderCellDef> Volume </th>
        <td mat-cell *matCellDef="let grid; let i = index" [attr.rowspan]="getRowSpan('volume', i)"
          [style.display]="getRowSpan('volume', i) ? '' : 'none'"> {{grid.volume}} </td>
      </ng-container>
      <ng-container matColumnDef="fonte">
        <th mat-header-cell *matHeaderCellDef>Fonte</th>
        <td mat-cell *matCellDef="let grid" matTooltip="{{grid.fonte}} - {{grid.tipoPeso}}">
          {{ grid.fonte }}
        </td>
      </ng-container>
      <ng-container matColumnDef="bruto">
        <th mat-header-cell *matHeaderCellDef>Bruto (kg)</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.bruto === null || grid.bruto === 0 ? '-' : grid.bruto | number }}
        </td>
      </ng-container>
      <ng-container matColumnDef="cubado">
        <th mat-header-cell *matHeaderCellDef>Cubado (kg)</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.cubado === null || grid.cubado === 0 ? '-' : grid.cubado | number }}
        </td>
      </ng-container>
      <ng-container matColumnDef="cubadoCalculado">
        <th mat-header-cell *matHeaderCellDef>Cubado Calculado (kg)</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.cubadoCalculado === null || grid.cubadoCalculado === 0 ? '-' : grid.cubadoCalculado | number}}
        </td>
      </ng-container>
      <ng-container matColumnDef="dataPesagem">
        <th mat-header-cell *matHeaderCellDef>Data Pesagem</th>
        <td mat-cell *matCellDef="let grid">
          {{ grid.dataPesagem | date:'dd/MM/yyyy HH:mm:ss'}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div *ngIf="!pedido?.pesoNrt || pedido?.pesoNrt.length == 0" style="min-height: 100px"
    class="d-flex justify-content-center align-items-center">
    <strong>Não há informação a ser exibida!</strong>
  </div>
</div>
